import prepareTranslate from '@/helpers/dictionary';
import PropTypes from 'prop-types';
import SectionView from '@/components/SectionView';
import Modal from '@/components/DetailsModal';
import { formatDateToString, stripHtmlTags } from '@/helpers/string';
import { Button } from '@mantine/core';

const ViewAgentEmail = (props) => {
  const {
    email,
    open,
    close,
    opened,
  } = props;

  const t = prepareTranslate();

  const emailName = [
    {
      title: 'שם המייל',
      value: email?.name,
    },
  ];

  const emailContent = [
    {
      title: 'תוכן המייל',
      value: stripHtmlTags(email?.content),
    },
  ];

  const emailDate = [
    {
      title: 'תאריך',
      value: formatDateToString(email?.date),
      files: email?.files,
    },
  ];

  // An original send needs no label - only a resend is called out.
  const emailSendDetails = [
    ...(email?.sendType === 'resend' ? [{
      title: t('components.viewAgentEmails.columns.sendType'),
      value: t('components.viewAgentEmails.sendTypes.resend'),
    }] : []),
    ...(email?.resendReason ? [{
      title: t('components.viewAgentEmails.columns.resendReason'),
      value: email.resendReason,
    }] : []),
    ...(email?.deletionReason ? [{
      title: t('components.viewAgentEmails.delete.reason'),
      value: email.deletionReason,
    }] : []),
  ];

  const actions = [
    <Button key='close' onClick={close}>
      {t('global.close')}
    </Button>,
  ];

  return (
    <Modal
      open={open}
      close={close}
      opened={opened}
      actions={actions}
      label={t('components.viewAgentEmails.label')}
    >
      <SectionView lines={emailName} autoFit={true} />
      <SectionView lines={emailContent} autoFit={true} />
      <SectionView lines={emailDate} autoFit={true} />
      {emailSendDetails.length > 0 && (
        <SectionView lines={emailSendDetails} autoFit={true} />
      )}
    </Modal>

  );
};

ViewAgentEmail.propTypes = {
  email: PropTypes.object,
  open: PropTypes.func,
  close: PropTypes.func,
  opened: PropTypes.bool,

};

export default ViewAgentEmail;
